import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

const el = document.querySelector('#helptab');
if (el) {
   setTimeout(() => {
      setHelpTabTransition(el, 'duration-500');
      el.style.right = '-95px';
   }, 1000);
   el.addEventListener('mouseenter', () => {
      setHelpTabTransition(el, 'duration-200');
      el.style.right = '-40px';
   });
   el.addEventListener('mouseleave', () => {
      setHelpTabTransition(el, 'duration-200');
      el.style.right = '-95px';
   });
   el.addEventListener('click', () => {
      trackAnalyticsCustomEvent({
         eventCategory: 'Help Tab',
         eventAction: 'Click',
      });
   });
}

function setHelpTabTransition(el, durationClass) {
   el.classList.remove('duration-200', 'duration-500');
   el.classList.add('transition-all', 'ease-out', durationClass);
}
